import React from 'react'
import { Link } from 'react-router-dom'

export default function ArticleSectionItem({cover, id, category, title, subtitle, author}) {
  return (
    <Link onClick={() => {
      window.scrollTo(0, 0)
    }} to={`/article/${id}`}  className='article-sedction-item-cont'>
        <img className='article-sedction-item-img' src={cover} alt="" />
        <div  className='mid-item-text-cont'>
            <div className='row100'>
            {author ? <p className="mid-item-author">Por {author}</p> : <></>}
            <p className="top-item-category"> {category} </p>
            </div>
    
            <p className='mid-item-title'> {title} </p>
            <p className='mid-item-subtitle'> {subtitle} </p>

        </div>
    </Link>
  )
}
